import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './guest-status.scss';

const GuestStatus = ({ color, label, className }) => (
  <>
    <span className={styles.guestStatusDot} style={{ color }} aria-hidden={true}>
      &#8226;
    </span>
    <span
      className={classnames(styles.guestStatusLabel, {
        [className]: !!className,
      })}
    >
      {label}
    </span>
  </>
);

GuestStatus.propTypes = {
  color: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default GuestStatus;
